import React from 'react';
import Text from 'ui/Text';

import '../styles/finished-pool.css';
import { formatDenmarkCurrency } from 'utils/UiHelper';

const PoolContentItem = ({
    title = '',
    price = 0,
    divider = false,
    bold = false,
    padding,
}) => {
    return (
        <div className={`flex ${divider && 'finished-pool-divider'}`}>
            <Text
                size={'x1'}
                color={'#333'}
                condensed
                align={'left'}
                padding={padding}
                bold={bold}
            >
                {title}
            </Text>
            <Text
                size={'x1'}
                color={'#333'}
                condensed
                align={'right'}
                padding={padding}
                bold={bold}
            >
                {formatDenmarkCurrency(price)} kr.
            </Text>
        </div>
    );
};

const FinishedPoolInfo = ({ payout = null }) => {
    return (
        <div className={'finished-pool-wrapper flex flex-columns'}>
            <div className={'finished-pool-content'}>
                <PoolContentItem
                    title={'Samlet indsats'}
                    price={payout?.poolSpentAmount}
                    padding={'4px 0'}
                />
                <PoolContentItem
                    title={'Samlet gevinst'}
                    price={payout?.poolTotalWin}
                    divider
                    padding={'4px 0'}
                />
                <PoolContentItem
                    title={'Din samlede gevinst'}
                    price={payout?.userWin}
                    bold
                    padding={'15px 0 4px'}
                />
            </div>
            <div className={'finished-pool-refund'}>
                <Text
                    size={'x1'}
                    color={'#333'}
                    align={'center'}
                    condensed
                    bold
                    padding={'0 0 10px 0'}
                >
                    Restbeløb fra puljen:{' '}
                    {formatDenmarkCurrency(payout?.poolLeftOverAmount)} kr.
                </Text>
                <Text
                    size={'x1'}
                    color={'#333'}
                    align={'center'}
                    condensed
                    padding={'0'}
                >
                    Din andel heraf bliver refunderet på din konto
                </Text>
                <a
                    className="profit-link"
                    href="https://intercom.help/25syv/da/articles/6686951-spilklub-udregning"
                    target="_blank"
                >
                    Sådan udregnes din gevinst
                </a>
            </div>
        </div>
    );
};

export default FinishedPoolInfo;
